export const DIAGNOSTIC_NUDGE_SESSION_KEY = "water-doctor:diagnostic-nudge:v1";
export const DIAGNOSTIC_NUDGE_SUPPRESS_EVENT = "water-doctor:diagnostic-nudge-suppress";

export function hasSeenDiagnosticNudge(storage) {
  try {
    return storage?.getItem(DIAGNOSTIC_NUDGE_SESSION_KEY) === "seen";
  } catch {
    return false;
  }
}

export function markDiagnosticNudgeSeen(storage) {
  try {
    storage?.setItem(DIAGNOSTIC_NUDGE_SESSION_KEY, "seen");
  } catch {
    // Storage can be unavailable in strict privacy modes. The in-memory UI
    // state still prevents another prompt during the current page view.
  }
}

export function hasSeenDiagnosticNudgeInWindow(windowObject) {
  try {
    return hasSeenDiagnosticNudge(windowObject?.sessionStorage);
  } catch {
    return false;
  }
}

export function markDiagnosticNudgeSeenInWindow(windowObject) {
  try {
    markDiagnosticNudgeSeen(windowObject?.sessionStorage);
  } catch {
    // Accessing the storage object itself can fail in strict privacy modes.
  }
}

export function suppressDiagnosticNudge(windowObject) {
  if (!windowObject) return;
  markDiagnosticNudgeSeenInWindow(windowObject);
  const EventConstructor = windowObject.Event || Event;
  windowObject.dispatchEvent(new EventConstructor(DIAGNOSTIC_NUDGE_SUPPRESS_EVENT));
}

export function hasReachedDiagnosticNudgeScroll({
  scrollY = 0,
  scrollHeight = 0,
  viewportHeight = 0,
  threshold = 0.3,
} = {}) {
  const availableScroll = Math.max(0, scrollHeight - viewportHeight);
  if (!availableScroll) return false;
  return Math.max(0, scrollY) / availableScroll >= threshold;
}
